import { ApiData, ApiMetaData } from 'types/api';
import { AppThunk } from 'redux/store';
import { endpoints } from 'api/endpoints';
import { isSuccessResult } from 'utils/guards';
import { Report } from 'types/api/responses';
import { apiGet, apiPut, getBlobTransfer } from 'api/karthus.client';
import { Json } from '../../types/common';
import { ReportActions, ReportsAction } from '../../types/redux/actions/reports.action';
import { format } from 'date-fns';
import { FilterWorkshop } from 'types/api/responses/workshop';

export const generateReport = async (filter: FilterWorkshop) => {
  const formatDate = (date: Date | string) => format(new Date(date), 'yyyy-MM-dd');
  
  
  const response = await getBlobTransfer(endpoints.reports.census, filter);

  if (response.status === 200) {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split('T')[0];
    const downloadUrl = window.URL.createObjectURL(new Blob([response.result as Blob]));
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.target = '_blank';
    link.setAttribute('download', `reporte_talleres_${formattedDate}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
};

export const allReports = (params: {
  page: number;
  size: number;
}): AppThunk<ReportsAction> => {
  return async (dispatch) => {
    dispatch({ type: ReportActions.FETCH_REPORTS, isLoading: true });
    const response = await apiGet<ApiMetaData<Report[]>>(endpoints.reports.get, {
      ...params,
    });
    if (isSuccessResult(response.result)) {
      dispatch({
        type: ReportActions.FETCH_REPORTS_SUCCESS,
        reports: {
          reports: response.result.data,
          meta: response.result.meta,
        },
      });
    } else {
      dispatch({
        type: ReportActions.FETCH_REPORTS_FAILURE,
        isLoading: false,
        error: response.result[0],
      });
    }
  };
};

export const updateReport = (data: Json): AppThunk<ReportsAction> => {
  return async (dispatch) => {
    dispatch({ type: ReportActions.UPDATE_REPORT, isLoading: true });
    const response = await apiPut<ApiData<any>>(endpoints.reports.update.all, data);
    if (isSuccessResult(response.result)) {
      dispatch({
        type: ReportActions.UPDATE_REPORT_SUCCESS,
        message: response.result.data,
      });
    } else {
      dispatch({
        type: ReportActions.UPDATE_REPORT_FAILURE,
        isLoading: false,
        error: response.result[0],
      });
    }
  };
};

export const compareReports = (data: Json): AppThunk<ReportsAction> => {
  return async (dispatch) => {
    dispatch({ type: ReportActions.COMPARE_REPORTS, isLoading: true });
    const response = await apiPut<ApiData<Report[]>>(endpoints.reports.compare, data);

    if (isSuccessResult(response.result)) {
      dispatch({
        type: ReportActions.COMPARE_REPORTS_SUCCESS,
        comparedReports: response.result.data,
      });
    } else {
      dispatch({
        type: ReportActions.COMPARE_REPORTS_FAILURE,
        isLoading: false,
        error: response.result[0],
      });
    }
  };
};
